import {
  muteRadio,
  pauseRadio,
  playRadio,
  unmuteRadio,
  radioMarqueeAnimationSubscribe,
  radioMuteToggleSubscribe,
  radioPauseSubscribe,
  radioPlaySubscribe,
  publishRadioState,
} from './workflows';
import { readFromLocalStorage, removeFromLocalStorage, writeToLocalStorage } from './localStorageHandlers';

export const createState = ({
  animationOn = false,
  id = '',
  marqueeText = '',
  muted = false,
  playing = false,
  playingLabel = '',
} = {}) => ({
  animationOn,
  id,
  marqueeText,
  muted,
  playing,
  playingLabel,
});

const state = createState();

export const setState = ({ newState = {}, publishState = true }) => {
  if (publishState) {
    publishRadioState(newState);
  }
  Object.assign(state, newState);

  return newState;
};

export const onMarqueeAnimationStart = (stateData) => () => {
  const newState = createState({ ...stateData, animationOn: true });
  setState({ newState, publishState: false });

  return newState;
};

export const onMuteToggle = (stateData) => () => {
  const newState = createState({ ...stateData, muted: !stateData.muted });

  if (newState.muted) {
    muteRadio();
  } else {
    unmuteRadio();
  }

  setState({ newState });
  writeToLocalStorage(newState);

  return newState;
};

export const onPauseClicked = () => {
  const newState = createState();

  pauseRadio();

  setState({ newState });
  removeFromLocalStorage();

  return newState;
};

export const onPlayClicked = ({ data }) => {
  const { id, label, marqueeText } = data;
  const newState = createState({ id, marqueeText, playing: true, playingLabel: label });

  playRadio(id);

  setState({ newState });
  writeToLocalStorage(newState);

  return newState;
};

export const afterInitRadio = (stateData) => (data) => {
  if (data) {
    const newState = createState({ ...stateData, ...data, animationOn: false });

    setState({ newState });

    return newState;
  }

  return {};
};

export const initRadio = () => {
  const data = readFromLocalStorage();

  radioMarqueeAnimationSubscribe(onMarqueeAnimationStart(state));
  radioMuteToggleSubscribe(onMuteToggle(state));
  radioPlaySubscribe(onPlayClicked);
  radioPauseSubscribe(onPauseClicked);

  afterInitRadio(state)(data);
};
